import { Candidate, CV } from '../api/AlqemiDataService';

/**
 * Get the default CV from a candidate's CV list
 * Returns the first CV if available, or an empty object
 */
export function getDefaultCV(candidate: Candidate | null | undefined): any {
  if (!candidate) return {};
  
  const cvs = candidate.cvs || [];
  if (cvs.length === 0) return {};
  
  // Return the content of the first CV
  return cvs[0].content || {};
}

/**
 * Get a specific CV by ID from a candidate's CV list
 */
export function getCVById(candidate: Candidate | null | undefined, cvId: string): any {
  if (!candidate) return {};
  
  const cvs = candidate.cvs || [];
  const cv = cvs.find(cv => cv.id === cvId);
  
  return cv?.content || {};
}

/**
 * Get CV content - either from a specific CV ID or the default
 */
export function getCVContent(candidate: Candidate | null | undefined, cvId?: string): any {
  if (cvId) {
    return getCVById(candidate, cvId);
  }
  return getDefaultCV(candidate);
}

/**
 * Check if candidate has any CVs
 */
export function hasCVs(candidate: Candidate | null | undefined): boolean {
  if (!candidate) return false;
  const cvs = candidate.cvs || [];
  return cvs.length > 0;
}

/**
 * Get the list of CVs for a candidate
 */
export function getCVList(candidate: Candidate | null | undefined): CV[] {
  if (!candidate) return [];
  return candidate.cvs || [];
}